var map = {
	"./RIK Root.svg": 88425,
	"./bell.svg": 9384,
	"./car_repair.svg": 3365,
	"./coins.svg": 14423,
	"./cvtv.svg": 28198,
	"./document.svg": 41764,
	"./user.svg": 88670,
	"./user_mic.svg": 81854,
	"./users.svg": 7041,
	"./warehouse.svg": 50132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36869;